import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { UserRole } from '@libs/shared/api';
import { Navigation } from '@sprint-backoffice/app/core/navigation/navigation.types';
import { map, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _navigation: ReplaySubject<Navigation> =
    new ReplaySubject<Navigation>(1);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for navigation
   */
  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this._httpClient.get<Navigation>('api/common/navigation').pipe(
      tap(navigation => {
        this._navigation.next(navigation);
      })
    );
  }

  getByUserRole(currentUserRole: UserRole): Observable<FuseNavigationItem[]> {
    return this.navigation$.pipe(
      map(navigation => {
        if (currentUserRole === UserRole.Admin) {
          return navigation.admin;
        } else if (currentUserRole === UserRole.SeniorManager) {
          return navigation.seniorManager;
        } else if (currentUserRole === UserRole.JuniorManager) {
          return navigation.juniorManager;
        } else {
          return [];
        }
      })
    );
  }
}
